<template>
    <div class="relative z-30 flex-shrink-0 flex h-14 items-center justify-center stage-sidebar-dark md:hidden">
        <router-link class="flex items-center justify-center h-full" :to="homeTo">
            <logo :div-padding="'px-0'" text-class="text-white"></logo>
        </router-link>
        <button aria-label="Open sidebar" class="absolute right-0 px-4 text-gray-300 focus:outline-none" @click="$emit('toggle-sidebar')">
            <svg-vue class="h-5 w-5" icon="font-awesome.regular.bars"></svg-vue>
        </button>
    </div>
</template>

<script>
import Logo from "@/components/layout/shared/logo_invert";

export default {
    name: "navbar",
    components: {Logo},
    emits: ['toggle-sidebar'],
    props: {
        homeTo: {
            type: String,
            required: false,
            default: '/workspace/dashboard',
        },
    },
}
</script>
